import { render } from "./UtenzeNew.vue?vue&type=template&id=4879414d&ts=true"
import script from "./UtenzeNew.vue?vue&type=script&lang=ts"
export * from "./UtenzeNew.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__